import LegalLayout, { LegalSection } from "@/components/LegalLayout";

const Cookiepolicy = () => (
  <LegalLayout title="Cookiepolicy" updated="1 juli 2026" testId="cookiepolicy-page">
    <LegalSection title="1. Vad är cookies?">
      <p>
        Cookies är små textfiler som lagras i din webbläsare när du besöker en webbplats. Liknande teknik, som
        webbläsarens lokala lagring (localStorage), används också för att komma ihåg inställningar.
      </p>
    </LegalSection>

    <LegalSection title="2. Nödvändig lagring">
      <p>
        Vi lagrar ditt val i cookie-bannern (nyckeln ”tillvia-cookie-consent”) i webbläsarens lokala lagring. Det är
        tekniskt nödvändigt för att komma ihåg ditt samtycke och kräver inget samtycke i sig.
      </p>
    </LegalSection>

    <LegalSection title="3. Analyscookies">
      <p>
        Om du väljer ”Acceptera alla” i cookie-bannern används analyseverktyget PostHog för att samla in anonymiserad
        statistik om hur webbplatsen används – till exempel vilka sidor som besöks och hur besökare navigerar.
        Informationen hjälper oss att förbättra webbplatsen. Väljer du ”Endast nödvändiga” avvisar du icke-nödvändiga
        cookies.
      </p>
    </LegalSection>

    <LegalSection title="4. Ingen tredjepartsannonsering">
      <p>
        Webbplatsen använder inga cookies för annonsering eller spårning från tredje parts annonsnätverk.
      </p>
    </LegalSection>

    <LegalSection title="5. Så hanterar du cookies">
      <p>
        Du kan när som helst ändra eller återkalla ditt samtycke genom att rensa webbplatsens lagrade data i din
        webbläsare – då visas cookie-bannern igen. Du kan också blockera cookies helt i webbläsarens inställningar,
        men vissa funktioner kan då sluta fungera som tänkt.
      </p>
    </LegalSection>

    <LegalSection title="6. Kontakt">
      <p>
        Frågor om cookies och integritet besvaras på{" "}
        <a
          href="mailto:info@tillvia.se"
          className="font-medium text-orange2 underline underline-offset-2 transition-colors hover:text-cream"
        >
          info@tillvia.se
        </a>
        . Läs även vår integritetspolicy för information om hur vi behandlar personuppgifter.
      </p>
    </LegalSection>
  </LegalLayout>
);

export default Cookiepolicy;
